<app-banner></app-banner>

<div id="side-navigation">
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-12 col-md-4 col-lg-3 side-menu ps-lg-5">
                <h6>Infrastructure</h6>
                <ul class="nav flex-column">
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/computer">Computer Lab</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/labs">Specialized Lab</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/library">Library</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/garden">Herbal Garden</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/conference">Conference Room</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/hostel">Hostel Facility</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/cafeteria">Cafeteria</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/internet">Internet Facility</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/sports">Sports Center</a>
                    </li>
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/infra/animal">Animal House</a>
                    </li>
                </ul>
            </div>
            <div class="col-md-9">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>